import Brand from './brandUtil'
import isEmpty from './isEmpty'
import router from '../router'
import { AppBrands, BrandEnum } from '../constants'

const lockedFlowKey = 'lockedFlow'

export default class RouterUtil {
  static isRouteInFlow = (flow, route = router.currentRoute) => {
    if (isEmpty(route) || isEmpty(route.matched) || isEmpty(flow)) {
      return false
    }

    for (let i = route.matched.length - 1; i >= 0; i--) {
      if (route.matched[i].meta && route.matched[i].meta.flow === flow) {
        return true
      }
    }

    return false
  }

  static getCurrentRouteFlow = (route = router.currentRoute) => {
    if (isEmpty(route) || isEmpty(route.matched)) {
      return ''
    }

    for (let i = route.matched.length - 1; i >= 0; i--) {
      if (route.matched[i].meta && !isEmpty(route.matched[i].meta.flow)) {
        return route.matched[i].meta.flow
      }
    }
  }

  static getAllRouteFlows = (route = router.currentRoute) => {
    if (isEmpty(route) || isEmpty(route.matched)) {
      return []
    }

    const flows = []
    for (let i = route.matched.length - 1; i >= 0; i--) {
      if (route.matched[i].meta && !isEmpty(route.matched[i].meta.flow)) {
        flows.push(route.matched[i].meta.flow)
      }
    }

    return flows
  }

  static getCurrentRouteBrand = (route = router.currentRoute) => {
    if (isEmpty(route) || isEmpty(route.matched)) {
      return 'None'
    }

    for (let i = route.matched.length - 1; i >= 0; i--) {
      if (route.matched[i].meta && !isEmpty(route.matched[i].meta.brand)) {
        return route.matched[i].meta.brand
      }
    }

    return 'None'
  }

  static getCurrentRouteBrandEnum = (route = router.currentRoute) => {
    if (isEmpty(route) || isEmpty(route.matched)) {
      return BrandEnum.None
    }

    for (let i = route.matched.length - 1; i >= 0; i--) {
      if (route.matched[i].meta && !isEmpty(route.matched[i].meta.brand)) {
        return BrandEnum[route.matched[i].meta.brand] || BrandEnum.None
      }
    }

    return BrandEnum.None
  }

  static getCurrentRouteBrandClass = (route = router.currentRoute) => {
    if (isEmpty(route) || isEmpty(route.matched)) {
      return BrandEnum.None
    }

    const brand = RouterUtil.getCurrentRouteBrandEnum(route)
    return Brand.getAppBrandByRouteBrand(brand) || process.env.VUE_APP_AppBrand || AppBrands.tmx // Default should never happen
  }

  static getRouteBrandByAppBrand = (appBrand = process.env.VUE_APP_AppBrand) => {
    switch (appBrand) {
      case AppBrands.c1l:
        return BrandEnum.Cash1Loans

      case AppBrands.ccc:
        return BrandEnum.CaliforniaCheckCash

      case AppBrands.ccf:
        return BrandEnum.CommunityChoice

      case AppBrands.chs:
        return BrandEnum.CheckSmart

      case AppBrands.cic:
        return BrandEnum.CheckIntoCash

      case AppBrands.esm:
        return BrandEnum.EasyMoney

      case AppBrands.inl:
        return BrandEnum.InstaLoan

      case AppBrands.tbs:
        return BrandEnum.TitleBucks

      case AppBrands.tmx:
        return BrandEnum.TitleMax

      default:
        return BrandEnum.None
    }
  }

  /**
   * Sets the flows that the customer can access
   * @param {Array<String>} flows The flows to allow access to
   * @returns {Boolean} True for success, false for failure
   */
  static setLockedFlows = flows => {
    if (Array.isArray(flows)) {
      sessionStorage.setItem(lockedFlowKey, JSON.stringify(flows))
      return true
    }

    return false
  }

  /**
   * Adds a flow to allow access
   * @param {String} flow The flow to allow access to
   * @returns {Boolean} True for success, false for failure
   */
  static addLockedFlow = flow => {
    const currentFlows = RouterUtil.getLockedFlows()
    if (currentFlows.indexOf(flow) < 0) {
      currentFlows.push(flow)
    }
    return RouterUtil.setLockedFlows(currentFlows)
  }

  /**
   * Removes a flow to prevent access
   * @param {Array} flow The flow to remove access to
   * @returns {Boolean} True for success, false for failure
   */
  static removeLockedFlow = flow => {
    const currentFlows = RouterUtil.getLockedFlows()
    currentFlows.splice(currentFlows.indexOf(flow), 1)
    return RouterUtil.setLockedFlows(currentFlows)
  }

  /**
   * Clears the current locked flows (allows full access)
   * @returns {Boolean} True for success, false for failure
   */
  static clearLockedFlows = () => {
    sessionStorage.removeItem(lockedFlowKey)
    return true
  }

  /**
   * Gets the flows that the customer has access to (empty array means they are not restricted)
   * @returns {Array<String>} The array of flows the customer has access to
   */
  static getLockedFlows = () => {
    const currentFlows = sessionStorage.getItem(lockedFlowKey)
    if (typeof currentFlows === 'string') {
      return JSON.parse(currentFlows)
    }

    return []
  }
}
